module.exports = __webpack_public_path__ + "static/media/eshcuFirstImg.0a332c5f.jpg";